import React, { useState, useContext } from 'react'
import DisplayItem from '../../displayItem/displayItem'
import styles from '../../uploadSummary/uploadSummary.module.scss'
import feeStyles from './fees.module.scss'
import Buttons from '../../buttons/buttons'
import { Context } from '../../context/provider'
import Loader from 'react-loader-spinner'
import { usePostError } from '../../../utilities/usePostError'
import axios from 'axios'
import { useSiteConfig } from '../../layout/getSiteConfig'

export default function BoatSummary() {
  const context = useContext(Context)
  const storage = typeof window !== 'undefined' ? window.sessionStorage : {}
  const [loader, setLoader] = useState(false)
  const handleError = usePostError()
  const { boatRenewalInfoApi } = useSiteConfig()

  const { name, email, phone, boatNumber, boatYear, Fee, Penalty, rollNumber, transactionId, ExpireDate } = storage;

  function formatNum(num) {
    return (Math.round(num * 100) / 100).toFixed(2);
  }

  function handleFees() {
    const fee = storage.Fee ? parseFloat(storage.Fee) : 0;
    const penalty = storage.Penalty ? parseFloat(storage.Penalty) : 0;
    const total = formatNum(fee + penalty);
    return total;
  }

  const handleNext = async () => {
    setLoader(true)
    window.sessionStorage.setItem('mcn-form-path', 'renew-boat')

    const body = {
      key: process.env.GATSBY_SECRET,
      storage: {
        name,
        rollNumber,
        email,
        transactionId,
        phone,
        boatNumber,
        boatYear,
        Fee,
        Penalty,
        ExpireDate
      }
    }

    try {
      await axios.post(boatRenewalInfoApi, { ...body })

      setLoader(false)
      context.setCurrent(2)

    } catch(e) {
      setLoader(false)
      handleError(e)
    }
  }
  
  const handleBack = () => {
    context.setCurrent(0)
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2>Summary</h2>

        <DisplayItem {...{
          value: boatNumber,
          label: 'Boat HIN / Serial #',
        }} />
        <DisplayItem {...{
          value: boatYear,
          label: 'Boat Year',
        }} />
        <DisplayItem {...{
          value: name,
          label: 'Name',
        }} />
        <DisplayItem {...{
          value: email,
          label: 'Email',
        }} />
        <DisplayItem {...{
          value: phone,
          label: 'Phone',
        }} />
        <DisplayItem {...{
          value: rollNumber,
          label: 'Citizen roll number',
        }} />
        <DisplayItem {...{
          label: 'Tag expiration',
          value: ExpireDate,
          display: (val) => new Date(val).toDateString()
        }} />

        <div className={feeStyles.fees}>
          <DisplayItem {...{
            value: Fee,
            display: (val) => `$${formatNum(val)}`,
            label: 'Fee',
            showCheck: false,
          }} />

          <DisplayItem {...{
            value: Penalty,
            display: (val) => `$${formatNum(val)}`,
            label: 'Penalty',
            showCheck: false,
          }} />

          <hr className={feeStyles.feeLine}></hr>

          <DisplayItem {...{
            value: Fee || Penalty,
            display: () => '$' + handleFees(),
            label: 'Total',
            total: true,
            showCheck: false,
          }} />
        </div>

        <Buttons {...{
          handleBack,
          handleNext,
          backLabel: 'BACK',
          nextLabel: 'PAYMENT'
        }}>
          {loader && <div className={styles.loader}>
            <Loader type="ThreeDots" color="#2BAF49" height={20} width={80} />
          </div>}
        </Buttons>
      </div>
    </section>
  )
}